<template>
    <div class="index-header">
        <div class="header-container">
            <a href="http://www.ftmespro.com">
                <img src="../resource/img/logo.png">
            </a>
            <div class="tab-groups">
                <div class="tab-item" data-idx="0" data-url="index">首页</div>
                <div class="tab-item more" data-idx="1" data-url="product">
                    <div class="tab-item-header">
                        <div class="tab-name">产品中心</div>
                        <div><i class="fa fa-angle-down"></i></div>
                    </div>
                    <div class="tab-item-content">
                        <div class="tab-item-row">机加工mes系统</div>
                        <div class="tab-item-row">铸造mes系统</div>
                        <div class="tab-item-row">热处理mes系统</div>
                        <div class="tab-item-row">工业数据采集系统</div>
                        <div class="tab-item-row">全流程质量追溯系统</div>
                        <div class="tab-item-row">仓储物流管理系统</div>
                        <div class="tab-item-row">设备管理系统</div>
                        <div class="tab-item-row">车间报工系统</div>
                        <div class="tab-item-row">电子看板</div>
                    </div>
                </div>
                <div class="tab-item" data-idx="2" data-url="solution">解决方案</div>
                <div class="tab-item more" data-idx="3" data-url="case">
                    <div class="tab-item-header">
                        <div class="tab-name">行业案例</div>
                        <div><i class="fa fa-angle-down"></i></div>
                    </div>
                    <div class="tab-item-content">
                        <div class="tab-item-row">机械加工行业</div>
                        <div class="tab-item-row">装备制造行业</div>
                        <div class="tab-item-row">橡胶及塑料行业</div>
                        <div class="tab-item-row">纺织服装行业</div>
                        <div class="tab-item-row">再生资源行业</div>
                    </div>
                </div>
<!--                <div class="tab-item more" data-idx="4">-->
<!--                    <div class="tab-item-header">-->
<!--                        <div class="tab-name">新闻资讯</div>-->
<!--                        <div><i class="fa fa-angle-down"></i></div>-->
<!--                    </div>-->
<!--                    <div class="tab-item-content">-->
<!--                        <div class="tab-item-row">公司动态</div>-->
<!--                        <div class="tab-item-row">行业资讯</div>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="tab-item" data-idx="5" data-url="about">关于我们</div>
                <div class="tab-item" data-idx="6" data-url="contact">联系我们</div>
                <div class="tab-item readonly">
                    <span style="margin-right: 15px;">|</span>
                    <i class="fa fa-phone" style="font-size: 20px;margin-right: 10px;"></i>
                    <span style="font-size: 20px;">150 4119 0343</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "headerBar",

    props: {
        tabIndex: {
            type: String,
            default: '0'
        }
    },

    data() {
        return {
            tab_idx: 0
        }
    },
    mounted() {
        this.tab_idx = Number(this.tabIndex);

        $(".tab-groups .tab-item").removeClass("active");
        $(".tab-item[data-idx='" + this.tab_idx + "']").addClass("active");

        let $more = $(".tab-item.more");
        $more.mouseover(function() {
            $(this).addClass("hover");
        });
        $more.mouseleave(function() {
            $(this).removeClass("hover");
        });

        let that = this;
        $(".tab-item:not(.readonly)").click(function(e) {
            e.stopPropagation();
            that.clickMenu({name: $(this).attr('data-url')});
        });

        $(".tab-item-row").click(function(e) {
            e.stopPropagation();

            let $tabItem = $(this).closest('.tab-item');
            let main_url = $tabItem.attr('data-url');
            let url = $(this).attr('data-url');
            if (main_url == 'product') {
                url = 'productDetail';
            } else if (main_url == 'case') {
                url = 'case';
            }

            $tabItem.removeClass("hover");
            that.clickMenu({name: url, params: {index: $(this).index()}});
        });

        this.$hub.$on('click-menu', (url) => {
            this.clickMenu({name: url});
        });
    },
    methods: {
        clickMenu(opt) {
            if (!opt.name) {
                return false;
            }

            if (this.$route.fullPath === '/' + opt.name) {
                this.$hub.$emit('changeMenu', opt);
                return false;
            }

            this.$router.replace(opt);
        },
    }
}
</script>

<style scoped>
.index-header {
    background: rgba(5, 26, 43, .9);
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 9999;
    height: 100px;
}

.index-header .header-container {
    width: 1615px;
    height: 100%;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tab-groups {
    display: flex;
    align-items: center;
    height: 100%;
}

.tab-groups .tab-item {
    height: 100%;
    padding: 0 20px;
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #FFFFFF;
    font-size: 18px;
    position: relative;
    transition: all 400ms;
}

.tab-groups .tab-item.readonly {
    cursor: auto;
}

.tab-groups .tab-item.active {
    font-family: "PingFang SC-Medium", "Source Han Sans CN", sans-serif;
    border-bottom: 5px solid #FFFFFF;
}

.tab-groups .tab-item .fa-angle-down {
    transition: all 200ms;
}

.tab-groups .tab-item:hover {
    background-color: rgba(69, 69, 69, 0.5);
}

.tab-groups .tab-item.hover .fa-angle-down {
    transform: rotate(180deg);
}

.tab-item-header {
    display: flex;
    align-items: center;
}

.tab-name {
    margin-right: 5px;
}

.tab-groups .tab-item.more::after {
    display: block;
    content: "";
    width: 0;
    border: 8px solid transparent;
    border-bottom-color: #051b33;
    position: absolute;
    bottom: -10px;
    opacity: 0;
    transition: all 400ms;
}

.tab-groups .tab-item.more.hover::after {
    opacity: 1;
    bottom: 0;
}

.tab-item-content {
    min-width: 200px;
    background: #051b33;
    position: absolute;
    top: 110px;
    left: 0;
    opacity: 0;
    visibility: hidden;
    width: 0;
    transition: all 200ms;
}

.tab-groups .tab-item.more.hover .tab-item-content {
    top: 100px;
    opacity: 1;
    visibility: visible;
}

.tab-item-row {
    color: #ffffff;
    padding: 8px 16px;
    cursor: pointer;
    font-size: 16px;
    border-bottom: 1px solid #2a3c4f;
}

.tab-item-content .tab-item-row:last-child {
    border-bottom: none;
}

.tab-item-row:hover {
    background-color: #333;
}
</style>
